<template lang="pug">
  DraggableList.b-stage-list-nav(
    :itemsRaw="stages.filter(s => s.id)"
    :canReceive="true"
    type="stage"
    v-slot="{ items, onDragStart, onDragEnter, onDragEnd, onDrop, draggableItem }"
    @change="resort"
  )
    ._item(
      v-for="(stage, i) in items"
      :key="stage.id"
      :class="{ active: selected === stage, drag: draggableItem === stage }"
      @click="$emit('select', stage.id)"
      draggable
      @dragstart="onDragStart($event, stage)"
      @dragenter="onDragEnter($event, stage)"
      @dragover.prevent
      @dragend="onDragEnd(stage)"
      @drop="onDrop(stage)"
    ) {{ stage.name }}
      NotificationCount(:count="getNotificationCount(stage)")
</template>

<script>
import modelStage from '@/model/stage';

import DraggableList from '@/components/draggable/DraggableList.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';

export default {
  name: 'StageListNav',
  components: { DraggableList, NotificationCount },
  props: {
    stages: Array,
    selected: Object,
  },
  methods: {
    resort(items) {
      modelStage.resort(items);
    },
    getNotificationCount(stage) {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return getter({ stageId: stage.id }).length;
    },
  },
};
</script>

<style scoped lang="scss">
  .stage-list-nav {
    display: grid;
    gap: 10px;

    &__item {
      cursor: pointer;
      padding: 14px 17px;
      background: #F8F9FC;
      border: 1px solid #F8F9FC;
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #1E3147;
      display: flex;
      justify-content: space-between;
      gap: 10px;
      align-items: flex-start;

      &:hover /*&.active*/ {
        border: 1px solid #FED56D;
      }
    }

  }
</style>
